var service = function($rootScope, $http, $q, C, RetailerContext) {
  var load = function(params = {}) {
    if (!$rootScope.user || $rootScope.user.signed_in === false) {
      return $q.when();
    }
    var defer = $q.defer();
    $http({
      method: 'GET',
      url: '/api/retailer/user/retailers',
      params: params
    }).then(function(res) {
      RetailerContext.initialize(res.data);
      defer.resolve(res.data);
    }, function error(res) {
      defer.resolve(res.data)
    });
    return defer.promise;
  };

  var update = function(retailerId, liquorLicense, successCallback, errorCallback) {
    $http({
      method: 'PUT',
      url: `/api/retailer/user/retailers/${retailerId}`,
      data: {
        retailer: {
          liquor_license: liquorLicense
        }
      }
    }).then(function success(res) {
      if (successCallback) {
        let currentRetailer = $rootScope.getCurrentRetailer();
        currentRetailer.liquor_license = liquorLicense;
        successCallback(liquorLicense);
      }
    }, function error(res) {
      if (errorCallback) {
        errorCallback(res);
      }
    });
  };

  return {
    load: load,
    update: update
  };

};

service.$inject = ['$rootScope', '$http', '$q', 'C', 'RetailerContext'];

tiz.service('Retailers', service);
export default service;